<template>
    <b-card>
        <div v-if="loading" class="loading"/>

        <div class="mb-2 mt-2">
            <div class="d-block d-md-inline-block pt-1">
                <h4 class="mb-2 card-title">List of Billings</h4>
            </div>

            <div class="float-md-right pt-1">
                <span class="text-muted text-small mr-1 mb-2">{{ meta.from }}-{{ meta.to }} of {{ meta.total }}</span>
                <b-dropdown id="ddown2" right :text="`${meta.per_page}`" variant="outline-dark"
                            class="d-inline-block" size="xs">
                    <b-dropdown-item v-for="(size,index) in meta.page_sizes" :key="index"
                                     @click="changePageSize(size)">{{ size }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>

        <b-table show-empty no-sort-reset class="vuetable" :current-page="meta.current_page" :per-page="meta.per_page"
                 :fields="table.fields" :items="fetchVendorBillings">
            <template v-slot:cell(id)="data">
                <router-link class="text-data-link" :to="{path : '/hms/locations/' + data.item.links.self}"
                             v-text="data.item.data.attributes.code"/>
            </template>

            <template v-slot:cell(facility)="data">
                <span v-text="data.item.data.attributes.facility"/>
            </template>

            <template v-slot:cell(date)="data">
                <span v-text="data.item.data.attributes.period"/>
            </template>

            <template v-slot:cell(rate)="data">
                <span v-text="data.item.data.attributes.rate"/>
            </template>

            <template v-slot:cell(total)="data">
                <span v-text="data.item.data.attributes.total"/>
            </template>

            <template v-slot:cell(created_at)="data">
                <span v-text="data.item.data.attributes.created_at"/>
            </template>
        </b-table>

        <b-pagination size="sm" align="center" :total-rows="meta.total" :per-page="meta.per_page"
                      v-model="meta.current_page">
            <template v-slot:next-text>
                <i class="simple-icon-arrow-right"/>
            </template>

            <template v-slot:prev-text>
                <i class="simple-icon-arrow-left"/>
            </template>

            <template v-slot:first-text>
                <i class="simple-icon-control-start"/>
            </template>

            <template v-slot:last-text>
                <i class="simple-icon-control-end"/>
            </template>
        </b-pagination>
    </b-card>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: "VendorBillingsList",
        data() {
            return {
                loading: true,
                table: {
                    fields: [
                        {key: 'id', label: 'Code'},
                        {key: 'facility', label: 'Facility', tdClass: 'text-muted'},
                        {key: 'date', label: 'Period', tdClass: 'text-muted'},
                        {key: 'rate', label: 'Rate', tdClass: 'text-muted text-right'},
                        {key: 'total', label: 'Total', tdClass: 'text-muted text-right'},
                        {key: 'created_at', label: 'Created At', tdClass: 'text-muted'},
                    ]
                }
            }
        },

        computed: {
            ...mapGetters({
                meta: 'getVendorBillingsMeta',
            }),
        },

        methods: {
            changePageSize(per_page) {
                this.meta.per_page = per_page;
            },

            fetchVendorBillings() {
                return this.$store.dispatch('fetchVendorBillings', this.$route.params.vendor_id)
                    .then(billings => {
                        return billings.data;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
        }
    }
</script>

<style scoped>

</style>
